import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { ElementType, PaymentMethodsCommandNames, sendRioEvent, SpecType, StatusTypes, SubType, UserAddressCommandNames } from '@chegg/commerce-utils';
import { venmoInitialize } from '../../redux/MopOnFileState/MopOnFileState.actions';
import { saveUserAddressCommands } from '../../redux/CommandState/CommandState.actions';
import { doFireStatusUpdate, sendRioEventCallback } from '../../utils/CallbackUtils';
import { Component } from '../../constants/CallbackConstants';
import { ERRORS } from '../../constants/Errors';
import { createMOP } from '../../redux/PaymentState/PaymentState.actions';
import { ACCOUNT_TYPE } from '../../constants/PaymentTypes';
import { getString } from '../../constants/Strings';
import { PAYMENT_PROCESSOR_TYPE } from '@chegg/checkout-sdk';
/**
 * onFormSubmit util invokes as soon as user clicks on Add Venmo CTA
 * @param params
 */
export var onAddVenmoClick = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
    var event, dispatch, rioNamespace;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          event = params.event, dispatch = params.dispatch, rioNamespace = params.rioNamespace;
          event === null || event === void 0 || event.preventDefault();
          sendRioEvent({
            info: getString('APP.RIO.EVENTS.EL_NAME.ADD_VENMO_BUTTON_CLICKED'),
            specType: SpecType.INTERACTION,
            subType: SubType.CLICK,
            namespace: rioNamespace,
            callback: sendRioEventCallback,
            elementType: ElementType.BUTTON
          });
          dispatch(venmoInitialize({
            venmoSubmit: true
          }));
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function onAddVenmoClick(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * submit venmo mop when venmoSubmit is true
 * @param params
 */
export var venmoSubmitMop = function venmoSubmitMop(params) {
  var payment = params.payment,
    mopOnFile = params.mopOnFile,
    dispatch = params.dispatch;
  var venmo = mopOnFile.venmo;
  var billingAddress = payment.billingAddress,
    deviceData = payment.deviceData;
  var zip = billingAddress.zip,
    country = billingAddress.country,
    line1 = billingAddress.line1,
    line2 = billingAddress.line2,
    city = billingAddress.city,
    state = billingAddress.state,
    isZipMandatory = billingAddress.isZipMandatory;
  dispatch(venmoInitialize({
    venmoSubmit: false
  }));
  if (!zip && isZipMandatory || !country) {
    dispatch(saveUserAddressCommands([{
      commandName: UserAddressCommandNames.VERIFY_ADDRESS
    }]));

    // return error callback for incomplete form
    doFireStatusUpdate([{
      status: StatusTypes.ERROR,
      command: PaymentMethodsCommandNames.FETCH_PAYMENT_METHOD,
      payload: {
        component: Component.VENMO_BILLING_ADDRESS,
        errors: [ERRORS.INLINE_ERRORS]
      }
    }]);
  } else {
    var _venmo$firstName, _venmo$lastName;
    dispatch(createMOP({
      nonce: venmo === null || venmo === void 0 ? void 0 : venmo.nonce,
      accountType: ACCOUNT_TYPE.VENMO,
      paymentProcessor: PAYMENT_PROCESSOR_TYPE.BRAINTREE,
      details: {
        firstName: (_venmo$firstName = venmo === null || venmo === void 0 ? void 0 : venmo.firstName) !== null && _venmo$firstName !== void 0 ? _venmo$firstName : '',
        lastName: (_venmo$lastName = venmo === null || venmo === void 0 ? void 0 : venmo.lastName) !== null && _venmo$lastName !== void 0 ? _venmo$lastName : '',
        billingAddress: {
          line1: line1 !== null && line1 !== void 0 ? line1 : '',
          line2: line2 !== null && line2 !== void 0 ? line2 : '',
          city: city !== null && city !== void 0 ? city : '',
          state: state !== null && state !== void 0 ? state : '',
          postalCode: zip,
          countryCode: country
        }
      },
      name: venmo === null || venmo === void 0 ? void 0 : venmo.username,
      deviceData: deviceData,
      billing: {
        city: city,
        state: state,
        zip: zip,
        country: country
      }
    }));
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/VenmoView/helper.js
// module id = 4564
// module chunks = 11